import React from 'react';
import { ASSETS } from '../../assetManifest';
import { CardType } from '../../types';

const Card = React.memo(({ card, isFaceDown = false, size = 'sm' }: { card: CardType | null; isFaceDown?: boolean; size?: 'sm' | 'lg' }) => {
  const colorMap: { [key: string]: string } = {
    // From new distribution
    lightblue: 'bg-gradient-to-br from-sky-400 to-sky-500',
    purple: 'bg-gradient-to-br from-purple-500 to-purple-600',
    orange: 'bg-gradient-to-br from-orange-500 to-orange-600',
    darkred: 'bg-gradient-to-br from-red-800 to-red-900',
    lightgreen: 'bg-gradient-to-br from-lime-400 to-lime-500',
    red: 'bg-gradient-to-br from-red-500 to-red-600',
    yellow: 'bg-gradient-to-br from-yellow-400 to-yellow-500',
    darkblue: 'bg-gradient-to-br from-blue-800 to-blue-900',
    green: 'bg-gradient-to-br from-green-500 to-green-600',
    pink: 'bg-gradient-to-br from-pink-400 to-pink-500',
  };

  const sizeClasses = {
    sm: {
      container: 'w-16 h-24',
      number: 'text-2xl',
      image: 'w-12 h-12',
      p: 'p-1',
      rounded: 'rounded-lg',
    },
    lg: {
      container: 'w-32 h-44',
      number: 'text-5xl',
      image: 'w-24 h-24',
      p: 'p-2',
      rounded: 'rounded-xl',
    }
  };
  const s = sizeClasses[size];

  if (isFaceDown) {
    return (
      <div className={`${s.container} ${s.rounded} shadow-2xl overflow-hidden border-2 border-white/20 transition-transform duration-200`}>
        <img src={ASSETS.cards.cardBack.path} alt="Card Back" className="w-full h-full object-cover" />
      </div>
    );
  }

  if (!card) return null;

  const imagePath = (ASSETS.faces as any)[card.imageAlias]?.path;

  return (
    <div className={`${s.container} ${s.rounded} shadow-2xl flex flex-col justify-start text-white ${colorMap[card.color]} border-2 border-white/30 transition-all duration-200`}>
      <div className={`w-full flex justify-start ${s.p}`}>
        <span className={`font-bold ${s.number} drop-shadow-lg`}>{card.number}</span>
      </div>
      <div className="flex-grow flex items-center justify-center">
        {imagePath && <img src={imagePath} alt={`Face for card ${card.number}`} className={`${s.image} object-contain drop-shadow-lg`} />}
      </div>
    </div>
  );
});

export default Card;
